@let avatarAttachment = profile()?.attachments | findFirstAttachmentByTypeId: 1;

<button #profileOrigin mat-icon-button (click)="openPanel()">
  @if (showAvatar && avatarAttachment) {
    <img class="aspect-square w-7 rounded-full object-cover" alt="" [src]="avatarAttachment?.attachment_url | secureImage" />
  }

  @if (!showAvatar || !avatarAttachment) {
    <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
  }
</button>

<ng-template #profilePanel>
  <div
    class="bg-card fixed inset-0 flex flex-col gap-3 overflow-hidden py-4 shadow-[0_0_4px_0_rgba(0,0,0,0.25)] sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl">
    <main class="flex items-center gap-4 px-6 py-4">
      @if (avatarAttachment) {
        <img class="h-[55px] w-[55px] rounded-full object-cover" alt="" [src]="avatarAttachment?.attachment_url | secureImage" />
      } @else {
        <div class="flex h-[55px] w-[55px] items-center justify-center rounded-full bg-slate-100 dark:bg-slate-700">
          <mat-icon class="icon-size-6" [svgIcon]="'heroicons_solid:user-circle'" />
        </div>
      }

      <aside class="flex flex-col gap-1">
        <span class="text-xl font-semibold">{{ profile()?.first_name }} {{ profile()?.last_name }}</span>
        <span>{{ profile()?.email }}</span>
      </aside>
    </main>
    <footer class="flex w-full flex-col border-t border-slate-300 pt-3">
      <button class="flex h-14 items-center gap-4 px-6 hover:cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700" (click)="toggleFullscreen()">
        <mat-icon
          class="!m-0 icon-size-5"
          [svgIcon]="fullScreenEnabled() ? 'heroicons_solid:arrows-pointing-in' : 'heroicons_outline:arrows-pointing-out'"></mat-icon>
        <span class="font-semibold text-accent dark:text-white">{{ fullScreenEnabled() ? 'Exit Full Screen' : 'Full Screen' }}</span>
      </button>
      @if (remoteConfig()?.language) {
        <button
          class="flex h-[50px] items-center justify-between px-6 hover:cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700"
          (click)="languageOpen.set(!languageOpen())">
          <ng-container *ngTemplateOutlet="langItem; context: { $implicit: activeLang() }"></ng-container>
          <mat-icon class="!m-0 icon-size-4" [svgIcon]="languageOpen() ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'"></mat-icon>
        </button>
      }

      @if (languageOpen()) {
        @for (lang of availableLangs; track lang) {
          <button
            class="flex h-[50px] items-center gap-4 px-9 hover:cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700"
            (click)="setActiveLang(getLangId(lang))">
            <ng-container *ngTemplateOutlet="langItem; context: { $implicit: getLangId(lang), enabledActive: true }"></ng-container>
          </button>
        }
      }

      @if (!environment.production) {
        @if (remoteConfig()?.theme) {
          <button
            class="flex h-14 items-center gap-4 px-6 hover:cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700"
            (click)="setScheme(config().scheme === 'light' ? 'dark' : 'light')">
            <mat-icon class="!m-0 icon-size-5" [svgIcon]="config().scheme === 'light' ? 'heroicons_outline:moon' : 'heroicons_solid:sun'"></mat-icon>
            <span class="font-semibold text-accent dark:text-white">{{ config().scheme === 'light' ? 'Dark Mode' : 'Light Mode' }}</span>
          </button>
        }
      }

      <button
        class="flex h-14 items-center gap-4 px-6 hover:cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700"
        [routerLink]="['/', ROUTE_NAMES.PAGES, ROUTE_NAMES.SETTINGS]">
        <mat-icon class="!m-0 icon-size-5" [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span class="font-semibold text-accent dark:text-white">Settings</span>
      </button>

      <button class="flex h-14 items-center gap-4 px-6 hover:cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700" (click)="signOut()">
        <mat-icon class="!m-0 text-warn icon-size-5" [svgIcon]="'heroicons_outline:arrow-right-start-on-rectangle'"></mat-icon>
        <span class="font-semibold text-warn">Sign Out</span>
      </button>

      <button class="flex h-14 items-center gap-4 px-6 hover:cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700 sm:hidden" (click)="closePanel()">
        <mat-icon class="!m-0 icon-size-5" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        <span class="font-semibold text-accent dark:text-white">Close</span>
      </button>
    </footer>
  </div>
</ng-template>
<ng-template #langItem let-lang let-enabledActive="enabledActive">
  <div class="flex items-center gap-4">
    <img class="w-6" [alt]="'Flag image for ' + lang" [src]="'images/flags/' + flagCodes[lang].toUpperCase() + '.svg'" />
    <span
      class="font-semibold"
      [class.text-primary]="enabledActive && lang === activeLang()"
      [class.dark:text-blue-400]="enabledActive && lang === activeLang()"
      >{{ flagLabels[lang] }}</span
    >
  </div>
</ng-template>
